

<template>
  <section class="content">
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document" style="width: 80%">
        <div class="modal-content">
          <div class="modal-header">  
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <gmap-map ref="mymap" :center="startLocation" :zoom="15" style="width: 100%; height: 500px">
              <gmap-info-window :options="infoOptions" :position="infoPosition" :opened="infoOpened" @closeclick="infoOpened=false">
                {{infoContent}}
              </gmap-info-window>
              <gmap-marker v-for="(item, key) in coordinates" :key="key" :position="getPosition(item)" :clickable="true" @click="toggleInfo(item, key)" />
            </gmap-map>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>-->
        </div> 
      </div>
    </div>
    <div id="tableBox">
      <div class="box-body">
        <!-- <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
          >
          <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#exampleModal">
            Show Map
          </button>
        </div> -->
        
        <v-server-table
          ref="livedetailsTable"
          url
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="map" slot-scope="props" >
            <div>
              <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#exampleModal" @click="getstartLocation(props.row)">
            Show Map
          </button>
            </div>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>
<script>

import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import moment from 'moment'
import axios from 'axios'
import Vue from 'vue'
export default {
  name : 'VehicleStatus',
  data(){
    return {
      startLocation: {
        lat:'',
        lng:''
      },
      mapMarkers:{},
      coordinates: {},
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {},
      pixelOffset: {
        width: 0,
        height: -35
      },
      timer:'',
      livedetails : {},
      USER_ROLES: USER_ROLES,
      loading: null,
      livedetailsTable: null,
      columns: [ 'vehicleNumber','currentTrip','driverIdDriverName', 'address' ,'transportSupervisorName' ,'recordedTime','locationIdSiteName','description','map'
      ],
      options: {
        highlightMatches: true,
        sortable: [ 'vehicleNumber','currentTrip','driverIdDriverName', 'address' ,'transportSupervisorName' ,'recordedTime','locationIdSiteName','description'
        ],
        headings: { 
          vehicleNumber : 'Vehicle',
          currentTrip: 'Current Trip',
          driverIdDriverName:'Driver',
          address : 'Address',
          transportSupervisorName : 'Transport Supervisor Details',
          recordedTime : 'Recorded Time',
          description: 'Status',
          locationIdSiteName : 'Last Known Location',
          map: ''
        },
        templates: {
          recordedTime(row,query){
            return moment(query.recordedTime).format('DD-MM-YYYY hh:mm A')
          },
          transportSupervisorName(row,query){
            if(query.transportSupervisorName && query.transportSupervisorContact){
              return `${query.transportSupervisorName},${query.transportSupervisorContact}`
            }
            if(query.transportSupervisorName){
              return `${query.transportSupervisorName}`
            }
            if(query.transportSupervisorContact){
              return `${query.transportSupervisorContact}`
            }
          },
          address(row,query){
            if(query.address){
              return `${query.address}` 
            }
          },
          map(row,query){
            this.startLocation = {
              lat : query.latitude,
              lng : query.longitude
            }
            return this.startLocation
          }
        },
        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$livedetailsDataRepository.list(params)
          // .then(res=> {
          //         //  let addres = [];
          //           let promisArr =[];
          //           this.addressValue = res.data.docs.map((item,index) => {
          //             if(item.latitude && item.longitude){
          //               promisArr.push(new Promise(function(resolve, reject){
          //                 Vue.$geocoder.setDefaultMode('lat-lng');
          //                   let latLngObj = {
          //                       lat: item.latitude,
          //                       lng: item.longitude
          //                   }
          //                   Vue.$geocoder.send(latLngObj, response => { 
       
          //                     res.data.docs[index]['address'] = response.results[0].formatted_address
          //                    //   addres.push(response.data.results[0].formatted_address)
          //                      resolve(response) 
          //                     });
          //                 // axios({
          //                 //     method: 'post',
          //                 //     url:  `https://maps.googleapis.com/maps/api/js/GeocodeService.Search?latlng=${item.latitude},${item.longitude}&key=AIzaSyBvu5T76L9QqcebnQuUYUAAsdrI-DmvGK4`,
          //                 // })
          //                 //   .then(response=> {                            
          //                 //     res.data.docs[index]['address'] = response.data.results[0].formatted_address
          //                 //    //   addres.push(response.data.results[0].formatted_address)
          //                 //      resolve(response)
          //                 //   }) 
          //               }))
          //             }
          //           })
          //           return Promise.all(promisArr).then(function(aaa){
          //               return res
          //           })
                                      
          //       })
          .catch(error => {
            console.error('liveStatus.requestFunction-error:', error);
            this.$snotify.error('Get Vehicle Status', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
      },
    };
  },
  created(){
    this.timer = setInterval(this.onLoaded1,60000)
    this.timer1 = setInterval(this.getVehicleStatus,60000)
  },
  mounted: function(){
    this.getVehicleStatus()
  },
  methods: {
    onLoaded1(){
      this.livedetailsTable = this.$refs.livedetailsTable.refresh();
    },
    getstartLocation(row){
      this.mapMarkers = {}
      if(row.latitude && row.longitude){
        this.startLocation = {
          lat : row.latitude,
          lng : row.longitude
        }
        this.mapMarkers = row
      }
      else{
        this.startLocation ={
          lat : 20.5937,
          lng : 78.9629
        }
      }
    },
    getPosition: function() {
      return {
        lat: parseFloat(this.mapMarkers.latitude),
        lng: parseFloat(this.mapMarkers.longitude)
      }
        
    },
    toggleInfo: function(marker, key) {
      this.infoPosition = this.getPosition()
      this.infoContent = this.mapMarkers.vehicleNumber
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened
      } else {
        this.infoOpened = true
        this.infoCurrentKey = key
      }
    },
    getVehicleStatus(){
      return this.$livedetailsDataRepository.list( {
        isDeleted: false
      })
      .then((response) => {
        this.livedetails = response.data;
        this.coordinates = response.data.docs;
      
      })
      .catch((error) => {
        this.$snotify.error('Trip detail failed', 'Error!')
      })
    },
    onLoaded() {
      
      this.livedetailsTable = this.$refs.livedetailsTable;
    }
  },
  computed: {
    addButtonClass() {
      if (this.livedetailsTable) {
        return this.livedetailsTable.count > this.livedetailsTable.limit ||
          this.livedetailsTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
  },
}
</script>

<style scoped>
.gradientbt{
  background: #0F6940;
  color: white;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
</style>


// WEBPACK FOOTER //
// VehicleStatus.vue?b1a5e93e